import { Button } from "@choose/ui/button";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <title>{`${t("not_found.title")} - ${t("app_name")}`}</title>
      <div className="bg-background h-0 min-h-[768px]">
        <main className="bg-background grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <p className="text-selected text-base font-semibold">404</p>
            <h1 className="text-foreground mt-4 text-5xl font-semibold tracking-tight text-balance sm:text-7xl">
              {t("not_found.title")}
            </h1>
            <p className="text-muted-foreground mt-6 text-lg font-medium text-pretty sm:text-xl/8">
              {t("not_found.description")}
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Button
                nativeButton={false}
                render={<Link to="/">{t("not_found.go_back_home")}</Link>}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
